/* tslint:disable */
/* eslint-disable */
/**
 * Ship to ship api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { S2SPairSchema } from './S2SPairSchema';
import {
    S2SPairSchemaFromJSON,
    S2SPairSchemaFromJSONTyped,
    S2SPairSchemaToJSON,
} from './S2SPairSchema';

/**
 * Schema for the event resource.
 * @export
 * @interface EventSchema
 */
export interface EventSchema {
    /**
     * Unique identifier for the record
     * @type {number}
     * @memberof EventSchema
     */
    id?: number | null;
    /**
     * Universal unique identifier for the record
     * @type {string}
     * @memberof EventSchema
     */
    uuid?: string | null;
    /**
     * Created at this point in time
     * @type {Date}
     * @memberof EventSchema
     */
    createdAt?: Date | null;
    /**
     * Created by this user
     * @type {string}
     * @memberof EventSchema
     */
    createdBy?: string | null;
    /**
     * Modified at this point in time
     * @type {Date}
     * @memberof EventSchema
     */
    modifiedAt?: Date | null;
    /**
     * Modified by this user
     * @type {string}
     * @memberof EventSchema
     */
    modifiedBy?: string | null;
    /**
     * 
     * @type {S2SPairSchema}
     * @memberof EventSchema
     */
    s2sPair: S2SPairSchema;
    /**
     * MMSI of the first vessel (auto-extracted from s2s_pair)
     * @type {number}
     * @memberof EventSchema
     */
    mmsiFirst?: number | null;
    /**
     * MMSI of the second vessel (auto-extracted from s2s_pair)
     * @type {number}
     * @memberof EventSchema
     */
    mmsiSecond?: number | null;
    /**
     * Time when the event was activated
     * @type {Date}
     * @memberof EventSchema
     */
    activationTime?: Date | null;
    /**
     * Time when the event was deactivated
     * @type {Date}
     * @memberof EventSchema
     */
    deactivationTime?: Date | null;
    /**
     * Severity level
     * @type {string}
     * @memberof EventSchema
     */
    severity?: string;
    /**
     * Name of the event
     * @type {string}
     * @memberof EventSchema
     */
    name?: string | null;
    /**
     * ID of the configuration that triggered this event
     * @type {number}
     * @memberof EventSchema
     */
    configurationId?: number | null;
    /**
     * Human-readable description of the activation
     * @type {string}
     * @memberof EventSchema
     */
    activationText?: string | null;
}

/**
 * Check if a given object implements the EventSchema interface.
 */
export function instanceOfEventSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "s2sPair" in value;

    return isInstance;
}

export function EventSchemaFromJSON(json: any): EventSchema {
    return EventSchemaFromJSONTyped(json, false);
}

export function EventSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'uuid': !exists(json, 'uuid') ? undefined : json['uuid'],
        'createdAt': !exists(json, 'created_at') ? undefined : (json['created_at'] === null ? null : new Date(json['created_at'])),
        'createdBy': !exists(json, 'created_by') ? undefined : json['created_by'],
        'modifiedAt': !exists(json, 'modified_at') ? undefined : (json['modified_at'] === null ? null : new Date(json['modified_at'])),
        'modifiedBy': !exists(json, 'modified_by') ? undefined : json['modified_by'],
        's2sPair': S2SPairSchemaFromJSON(json['s2s_pair']),
        'mmsiFirst': !exists(json, 'mmsi_first') ? undefined : json['mmsi_first'],
        'mmsiSecond': !exists(json, 'mmsi_second') ? undefined : json['mmsi_second'],
        'activationTime': !exists(json, 'activation_time') ? undefined : (json['activation_time'] === null ? null : new Date(json['activation_time'])),
        'deactivationTime': !exists(json, 'deactivation_time') ? undefined : (json['deactivation_time'] === null ? null : new Date(json['deactivation_time'])),
        'severity': !exists(json, 'severity') ? undefined : json['severity'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'configurationId': !exists(json, 'configuration_id') ? undefined : json['configuration_id'],
        'activationText': !exists(json, 'activation_text') ? undefined : json['activation_text'],
    };
}

export function EventSchemaToJSON(value?: EventSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'uuid': value.uuid,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt === null ? null : value.createdAt.toISOString()),
        'created_by': value.createdBy,
        'modified_at': value.modifiedAt === undefined ? undefined : (value.modifiedAt === null ? null : value.modifiedAt.toISOString()),
        'modified_by': value.modifiedBy,
        's2s_pair': S2SPairSchemaToJSON(value.s2sPair),
        'mmsi_first': value.mmsiFirst,
        'mmsi_second': value.mmsiSecond,
        'activation_time': value.activationTime === undefined ? undefined : (value.activationTime === null ? null : value.activationTime.toISOString()),
        'deactivation_time': value.deactivationTime === undefined ? undefined : (value.deactivationTime === null ? null : value.deactivationTime.toISOString()),
        'severity': value.severity,
        'name': value.name,
        'configuration_id': value.configurationId,
        'activation_text': value.activationText,
    };
}

